module.exports = __webpack_public_path__ + "static/media/note-site.eb759be9.png";